module.exports = __webpack_public_path__ + "img/gsndc2760_1.aa5bc49b.svg";